"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityComponentStore = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IEntityComponentStore}
 */
class EntityComponentStore {
    constructor() {
        this.components = new WeakMap();
    }
    getComponent(entity) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.components.has(entity), "expected to find component");
        return this.components.get(entity);
    }
    setComponent(entity, component) {
        this.components.set(entity, component);
    }
    deleteComponent(entity) {
        this.components.delete(entity);
    }
}
exports.EntityComponentStore = EntityComponentStore;
//# sourceMappingURL=entity-component-store.js.map